import { frFR } from "@material-ui/data-grid";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { findOne as findOneSalarie } from "../../../../services/Salarie__Service";
import {
  findAllBySalarie as findAllDocumentBySalarie,
  downloadfile,
} from "../../../../services/Document__Servive";
import navContext from "../../../Context/navContext";
import { MdDownload, MdOutlineRemoveRedEye, MdWarning } from "react-icons/md";
import notifyContext from "../../../Context/notifyContext";
import { useParams } from "react-router-dom";
import Loader from "../../../Loader/Loader";
import { ANNEE_TABS, MOIS_TABS } from "../../../../services/config";
import Modal from "../../../Modal/Modal";
import FormSalarie from "../../../Main/Components/Salarie/Form/FormSalarie";
import FormDocument from "../../../Main/Components/Document/Form/FormDocument";
import CardSalarie from "../../../CardSalarie/CardSalarie";
import { securityGestionnaire } from "../../../../services/Auth__Service";

const ListDocumentForOneSalarie = () => {
  /* Handle Modal */
  const [viewSalarieId, setViewSalarieId] = useState(0);
  const [viewDocumentId, setViewDocumentId] = useState(0);
  /* End Handle Modal */

  const paramsRoutes = useParams();

  const [id, setId] = useState(paramsRoutes.id);

  const [salarie, setSalarie] = useState(null);
  const [documents, setDocuments] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const nav = useContext(navContext);
  const notify = useContext(notifyContext);

  const downloadHandle = React.useCallback(
    (filename, nameDownload) => () => {
      downloadfile(filename, nameDownload);
    },
    []
  );

  const columns = useMemo(
    () => [
      {
        field: "proprietaireName",
        headerName: "Salarié",
        minWidth: 200,
        flex: 1,
        renderCell: (params) => (
          <p
            style={{ cursor: "pointer" }}
            onClick={() => setViewSalarieId(params.row.proprietaire)}
          >
            {params.value}
          </p>
        ),
      },
      {
        field: "moisString",
        headerName: "Mois",
        minWidth: 110,
        type: "singleSelect",
        valueOptions: MOIS_TABS,
      },
      {
        field: "annee",
        headerName: "Année",
        minWidth: 120,
        type: "singleSelect",
        valueOptions: ANNEE_TABS,
      },

      {
        field: "statut",
        headerName: "Statut",
        width: 120,
        valueGetter: (params) => {
          if (parseInt(params.row.statut) === 1) return "Modifiable";
          else return "Archivé";
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        width: 100,
        getActions: (params) => [
          <GridActionsCellItem
            icon={<MdDownload />}
            label="Télécharger"
            onClick={downloadHandle(params.row.chemin, params.row.nameDownload)}
            showInMenu
          />,
          <GridActionsCellItem
            icon={<MdOutlineRemoveRedEye />}
            label="Voir"
            onClick={() => setViewDocumentId(params.id)}
            showInMenu
          />,
        ],
      },
    ],
    [downloadHandle]
  );
  const getMoisString = (mois) => {
    mois = parseInt(mois);
    if (mois >= 1 && mois <= 12) return MOIS_TABS[mois - 1];
    else return "";
  };

  useEffect(() => {
    nav({
      links: [
        {
          href: "/client/salarie",
          linkname: "Salariés",
        },
        {
          href: "",
          linkname: salarie ? salarie.nom : "",
        },
      ],
      children: "",
    });
    if (!salarie) {
      fetchOneSalarie(id);
    } else {
      securityGestionnaire(salarie.client.id);
    }
  }, [salarie]);

  useEffect(() => {
    if (!isLoading) {
      let list = documents.map((doc) => {
        return {
          ...doc,
          moisString: getMoisString(doc.mois),
          proprietaireName: doc.salarie.fullname,
          employeurName: doc.salarie.client.nom,
          clientId: doc.salarie.client.id,
        };
      });
      setDocuments(list);
    }
  }, [isLoading]);

  const fetchOneSalarie = async (id) => {
    findOneSalarie(id)
      .then((response) => {
        setSalarie(response.data);
        fetchAllDocumentBySalarie(id);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      });
  };

  const fetchAllDocumentBySalarie = async (id) => {
    findAllDocumentBySalarie(id)
      .then((response) => {
        setDocuments(response.data);
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleChangeRowsPerPage = (numberRow) => {
    setRowsPerPage(parseInt(numberRow, 10));
  };

  return (
    <Fragment>
      <div className="document__items">
        <CardSalarie initialSalarie={salarie} />
        <h4>Liste des documents</h4>
        <div style={{ height: "100%", width: "100%", background: "#fff" }}>
          <DataGrid
            rows={documents}
            columns={columns}
            pageSize={rowsPerPage}
            rowsPerPageOptions={[10, 25, 50, 100]}
            loading={isLoading}
            onPageSizeChange={handleChangeRowsPerPage}
            localeText={frFR.props.MuiDataGrid.localeText}
          />
        </div>
      </div>
      {isLoading && <Loader loadingMsg="Chargement" />}

      {viewSalarieId !== 0 && (
        <Modal>
          <div className={`modal ${viewSalarieId !== 0 && "show"} `}>
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Détails Salarié</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setViewSalarieId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <FormSalarie salarieId={viewSalarieId} view={true} />
              </div>
              <div className="modal__footer">
                <button className="btn" onClick={() => setViewSalarieId(0)}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {viewDocumentId !== 0 && (
        <Modal>
          <div className="modal modal--show">
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Détails Document</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setViewDocumentId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <FormDocument documentId={viewDocumentId} view={true} />
              </div>
              <div className="modal__footer">
                <button className="btn" onClick={() => setViewDocumentId(0)}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </Fragment>
  );
};

export default ListDocumentForOneSalarie;
